/**
 * Captured before any polyfill loads: this module must be the FIRST import in
 * src/polyfills.ts, so it observes the browser's native capabilities.
 *
 * `Promise.withResolvers` (Safari 17.4 / Chrome 119) is the marker for the
 * browser generation that needs the PDF main-thread fallback: Safari 15
 * constructs module workers for pdfjs's worker but silently never executes
 * them (no error event), which otherwise hangs every PDF load forever.
 */
export const isLegacyBrowser = typeof Promise.withResolvers !== 'function';
